import { redstone as viemRedstone } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const redstone = {
  displayName: 'Redstone',
  runtime: 'evm',
  viemChain: viemRedstone,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'redstone' },
    qnStreams: {
      networkKey: 'redstone-mainnet',
    },
    pimlico: { chainSlug: 'redstone' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
